// Tiny observable store — no framework (docs/FRONTEND.md).

import type { User } from "./types";

export interface AppStateShape {
  user: User | null;
  provider: string;
  hostedMeetings: boolean;
  route: string; // current location.hash without '#'
}

type Listener = () => void;

class Store {
  private state: AppStateShape = { user: null, provider: "", hostedMeetings: false, route: "/" };
  private listeners = new Set<Listener>();

  get(): Readonly<AppStateShape> {
    return this.state;
  }

  set(patch: Partial<AppStateShape>): void {
    this.state = { ...this.state, ...patch };
    this.listeners.forEach((l) => l());
  }

  subscribe(l: Listener): () => void {
    this.listeners.add(l);
    return () => this.listeners.delete(l);
  }
}

export const store = new Store();

export function currentRoute(): string {
  return location.hash.replace(/^#/, "") || "/";
}

export function navigate(route: string): void {
  location.hash = `#${route}`;
}
